{
  "userSelect": {
    "placeholder": "Select user",
    "loading": "Loading...",
    "noUsers": "No users found",
    "error": "Error loading users",
    "search": "Search users...",
    "noResults": "No users found.",
    "allDepartments": "All departments",
    "usersSelected": "{{count}} users selected",
    "usersSelected_one": "{{count}} user selected",
    "usersSelected_other": "{{count}} users selected",
    "noManager": "No manager",
    "default": "Default"
  },
  "departmentSelect": {
    "placeholder": "Select department",
    "loading": "Loading...",
    "noDepartments": "No departments found",
    "error": "Error loading departments",
    "search": "Search departments...",
    "noResults": "No departments found.",
    "allDepartments": "All departments",
    "noParentDepartment": "No parent department"
  },
  "orgFunctionSelect": {
    "placeholder": "Select Function",
    "loading": "Loading...",
    "noOrgFunctions": "No Functions found",
    "error": "Error loading Functions",
    "search": "Search Functions...",
    "noResults": "No Functions found.",
    "noOrgFunction": "No Function"
  },
  "systemSelect": {
    "placeholder": "Select system",
    "loading": "Loading...",
    "noSystems": "No systems found",
    "error": "Error loading systems",
    "search": "Search systems...",
    "noResults": "No systems found.",
    "noSystem": "No system",
    "systemsSelected": "{{count}} selected"
  },
  "userTransferListbox": {
    "error": "Error loading users",
    "noUsers": "No users available",
    "availableUsers": "Available People",
    "selectedUsers": "Selected People",
    "searchUsers": "Search people…"
  },
  "surveyDialog": {
    "title": "Process Step Feedback",
    "description": "Your feedback helps improve processes. Please tell us how you experience this process step.",
    "ratingQuestion": "How well does this step work for you?",
    "commentPlaceholder": "Share your thoughts about this process step...",
    "frequencyQuestion": "How often do you perform this Process Step?",
    "frequencyPlaceholder": "Select frequency",
    "timesPerDayQuestion": "How many times per day?",
    "timesPerWeekQuestion": "How many times per week?",
    "timesPerPeriodPlaceholder": "Enter a number (e.g., 5)",
    "durationQuestion": "How long does this step take on average? (in minutes)",
    "durationPlaceholder": "Enter duration in minutes (e.g., 30)",
    "submit": "Submit Feedback",
    "cancel": "Cancel",
    "recordedBy": "Recorded by",
    "processStep": "Process Step",
    "ratingSection": "Your Feedback",
    "metricsSection": "Effort and frequency",
    "addCommentOptional": "Add comment",
    "variantQuestion": "Do you perform this step exactly like this?",
    "variantSame": "Yes, exactly like this",
    "variantSameDescription": "I perform the step exactly as described.",
    "variantDifferent": "Yes, but differently",
    "variantDifferentDescription": "I perform the step, but in my own way.",
    "variantNotPerformed": "I do not perform this step",
    "variantNotPerformedDescription": "This step is not part of my work.",
    "variantDescriptionQuestion": "What do you do differently?",
    "variantDescriptionPlaceholder": "Describe how your way of working differs...",
    "closedTitle": "This survey is closed",
    "closedCompleted": "Your answers have already been saved.",
    "closedDismissed": "You stated that you do not perform this step.",
    "closedNotApplicable": "There is nothing for you to answer in this survey."
  }
}
